import { Calculator, Search, MapPin, FileText, Hammer } from "lucide-react";

const STEPS = [
  {
    icon: Calculator,
    title: "Nos envías tu estimación",
    text: "Usa la calculadora o escríbenos directamente por WhatsApp con tu consulta.",
  },
  {
    icon: Search,
    title: "Revisamos el trabajo",
    text: "Analizamos medidas, fotos, materiales y condiciones reales de la obra.",
  },
  {
    icon: MapPin,
    title: "Visita técnica si es necesario",
    text: "Nos desplazamos a la vivienda, local o comunidad en Valencia y provincia.",
  },
  {
    icon: FileText,
    title: "Presupuesto detallado",
    text: "Te entregamos una propuesta clara con partidas, alcance y condiciones.",
  },
  {
    icon: Hammer,
    title: "Ejecución con garantía",
    text: "Coordinamos el equipo, protegemos la zona y cuidamos los acabados.",
  },
];

export default function HowWeWork() {
  return (
    <section id="como-trabajamos" className="bg-slate-50/60 border-y border-slate-200 scroll-mt-20">
      <div className="container mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="max-w-2xl mb-10 md:mb-14">
          <div className="text-[11px] uppercase tracking-[0.2em] text-[#004B87] font-semibold mb-3">Proceso de trabajo</div>
          <h2 className="font-display font-semibold text-3xl md:text-4xl text-slate-900 tracking-tight">
            Cómo trabajamos
          </h2>
          <p className="text-slate-500 mt-3">
            Un proceso claro, sin sorpresas, desde la primera consulta hasta la entrega final.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-3 md:gap-4">
          {STEPS.map((s, i) => (
            <div
              key={i}
              data-testid={`how-step-${i + 1}`}
              className="relative p-5 rounded-xl border border-slate-200 bg-white"
            >
              <div className="absolute -top-3 -left-3 w-8 h-8 rounded-lg bg-[#004B87] text-white font-display font-bold grid place-items-center shadow-md">
                {i + 1}
              </div>
              <div className="w-10 h-10 rounded-lg bg-[#E6F0FA] text-[#004B87] grid place-items-center mb-3 mt-2">
                <s.icon className="w-5 h-5" />
              </div>
              <div className="font-display font-semibold text-slate-900 text-[15px] leading-tight">{s.title}</div>
              <div className="text-xs text-slate-500 mt-2 leading-snug">{s.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
